/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Settings_Reportingapikeys_Generate_Expirydays3Inputs */

const en_settings_reportingapikeys_generate_expirydays3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Expirydays3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days`)
};

/**
* | output |
* | --- |
* | "{days} days" |
*
* @param {Settings_Reportingapikeys_Generate_Expirydays3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_expirydays3 = /** @type {((inputs: Settings_Reportingapikeys_Generate_Expirydays3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Expirydays3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_expirydays3(inputs)
});
export { settings_reportingapikeys_generate_expirydays3 as "settings_reportingApiKeys_generate_expiryDays" }